import { TransferTime } from '@/models/TransferTime'
import CachedResourceStore from '@/store/modules/CachedResourceStore'

export default new CachedResourceStore<TransferTime>(TransferTime, {
	namespaced: true
})
